




























import Candle from "@/models/candle";
import { Component, Prop, Vue } from "vue-property-decorator";

let canvasId = 0;
const fancyFlame = false;

function generateCandleStyle() {
  const rotate = Math.floor(Math.random() * 5 - 2);
  const skew1 = Math.floor(Math.random() * 2 - 1);
  const skew2 = Math.floor(Math.random() * 2 - 1);
  const scale = Math.random() * 0.25 + 0.85;
  return `transform: rotate(${rotate}deg) scaleY(${scale}) skew(${skew1}deg, ${skew2}deg);`;
}

function generateFlowerStyle() {
  const rotate = Math.floor(Math.random() * 5 - 2);
  const skew1 = Math.floor(Math.random() * 2 - 1);
  const skew2 = Math.floor(Math.random() * 2 - 1);
  const scale = Math.random() * 0.25 + 0.85;

  const left = (Math.ceil(Math.random() * 120)) - 55;
  return `left: ${left}px; transform: rotate(${rotate}deg) scaleY(${scale}) skew(${skew1}deg, ${skew2}deg);`;
}

const TOTAL_FLOWERS = 5;

@Component
export default class CandleImage extends Vue {
  private readonly candleCanvasId = "cc" + (canvasId += 1);
  private readonly candleStyle = generateCandleStyle();
  private readonly flowerStyle = generateFlowerStyle();

  private canvas?: HTMLCanvasElement;

  /**
   * Applies a random delay to the CSS animation.
   */
  private animationDelay = 0;

  @Prop()
  private candle?: Candle;

  @Prop({ default: false })
  private lit?: boolean;

  @Prop({ default: true })
  private flower?: boolean;

  @Prop({
    default: "normal",
    validator: (x) =>
      ["normal", "small", "big"].findIndex((y) => y === x) !== -1,
  })
  private scale?: string;

  get idNumberValue() {
    const idString = ((this.candle || {})._id || '00');
    const lastTwoDigits = idString.substr(idString.length - 2, 2);

    return Number.parseInt(lastTwoDigits, 16);
  }

  get text() {
    const name = (this.candle || {}).name;
    return name;
  }

  get isLit() {
    return this.lit || Boolean(this.candle);
  }

  get fancyFlame() {
    return fancyFlame;
  }

  get flowerSrc() {
    return require(`@/assets/flowers/${this.flowerNumber+1}.png`);
  }

  get flowerNumber() {
    const number = this.idNumberValue % TOTAL_FLOWERS;
    
    console.log('Number: ', number);

    return number;
  }

  // MARK: Lifecycle
  mounted() {
    /*
    if (fancyFlame) {
      const cElement: any = document.getElementById(this.candleCanvasId);
      const ctx = (this.canvas = cElement.getContext("2d"));

      // TODO: Entry point for creating flames on a canvas.
    }
    */

   setTimeout(() => {
      this.animationDelay = Math.ceil(Math.random() * 1000);
   }, 4000);
  }

  // MARK: Handlers
  handleClick() {
    this.$emit("click-candle", this.candle);
  }
}
